
import React, { PureComponent } from 'react';
import classNames from "class-names";

class InputClearifier extends PureComponent {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.state = {
            showClear: false,
        };
    }

    handleClear(event) {
        const aEvent = new Event('input', { bubbles: true });
        this.refs.input.value = "";
        this.refs.input.dispatchEvent(aEvent);
        this.setState({
            showClear: false,
        });
        this.invokeChange();
    }

    handleChange(event) {
        if (event.target.value) {
            this.setState({
                showClear: true,
            });
        } else {
            this.setState({
                showClear: false,
            });
        }
        this.invokeChange();
    }

    invokeChange() {
        this.props.onChange({
            target: this.refs.input,
        });
    }

    render() {

        return (
            <div className={classNames({
                "input-group": true,
                "input-group_controls": !!(this.props.additionalClassName || ""),
                "input-group_show-clear": this.state.showClear,
            })}>
                <input ref="input"
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.handleChange}
                    className={classNames({
                        "form-control form-control_medium-font form-control-lg modal-form__input transparent-input form-control_clearing": true,
                        [this.props.additionalClassName || ""]: true,
                    })}
                    disabled={!!this.props.disabled}
                    tabIndex={this.props.tabIndex}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    readOnly={!!this.props.readOnly}
                />
                {!!this.props.icons &&
                    this.props.icons
                }
                <button className="btn-new btn-new--icon input-group__clear-button"
                    type="button"
                    disabled={!!this.props.disabled}
                    onClick={this.handleClear}>
                    <svg className="icon icon--close" id="icon--close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.99629 4.85076C5.38681 4.46024 6.01998 4.46024 6.4105 4.85076L19.2658 17.7061C19.6564 18.0966 19.6564 18.7298 19.2658 19.1203L19.0945 19.2916C18.704 19.6821 18.0709 19.6821 17.6803 19.2916L4.825 6.43627C4.43447 6.04574 4.43447 5.41258 4.825 5.02206L4.99629 4.85076Z" />
                        <path
                            d="M4.85215 19.1203C4.46162 18.7298 4.46162 18.0966 4.85215 17.7061L17.7075 4.85075C18.098 4.46023 18.7312 4.46023 19.1217 4.85075L19.293 5.02205C19.6835 5.41257 19.6835 6.04574 19.293 6.43626L6.43765 19.2916C6.04713 19.6821 5.41396 19.6821 5.02344 19.2916L4.85215 19.1203Z" />
                    </svg>
                </button>
            </div>
        );
    }
}

export default InputClearifier;